import type { EditAssetWorkflowOptions } from '../../types';

export const addShipiumCredentials: EditAssetWorkflowOptions = {
  workflowKey: 'addShipiumCredentialsWorkflow',
  shipiumOnly: true,
  workflowIndex: 3,
  assetType: 'carrierAccount',
  workflowType: 'editAssetWorkflow',
  workflowName: 'Add Shipium Credentials',
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      carrierId: {
        oneOf: [
          { type: 'string', const: 'fedex' },
          { type: 'string', const: 'ups' },
          { type: 'string', const: 'upsmi' },
          { type: 'string', const: 'asendia' },
        ],
      },
    },
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'shipiumCredentials',
      workflowStepNavigationName: 'Shipium Credentials',
      workflowComponent: {
        carrierId: 'fedex',
        shipiumCredentials: true,
        workflowComponentType: 'credentialEntry',
        prompt: 'Enter shipium credentials?',
        description: 'Enter shipium credentials',
        help: 'Carrier requires shipium to enter credential information in addition to partners',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'shipiumCredentials',
      },
      calculatedComponentProps: {
        carrierId: {
          property: 'carrierId',
          type: 'asset',
        },
        credentials: {
          property: 'shipiumCredentials',
          type: 'asset',
        },
      },
    },
    {
      workflowStepKey: 'shipiumCredentialSummary',
      workflowStepNavigationName: 'Shipium Credential Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Shipium Credentials Summary',
        description: 'The following values will be saved.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
